<template>
  <div>
    <loading-view :isCardActive="loadingView" />
    <error-loading-view :isCardActive="errorLoadingView" @retry="loadTask" @hideView="errorLoadingView = false" />
    <div v-if="taskResults && !taskResults.quizId && !taskResults.uploadTaskId && !taskResults.videoCaptureTaskId">
      <div class="mb-3" v-for="(result, index) in taskResults.questions" :key="index">
        <div v-if="index == 0">
          <ispring-quiz-info-view :isCardActive="ispringQuizInfoView" :quizInfo="taskResults" :newScore="ispringTotalScore" />
        </div>
        <div v-if="result.questionType == 'MultipleChoice'">
          <multiple-choice-question :isCardActive="multipleChoiceQuestion" :question="result" :quizType="taskResults.quizSettings.quizType" />
        </div>
        <div v-else-if="result.questionType == 'MultipleResponse'">
          <multiple-response-question :isCardActive="multipleResponseQuestion" :question="result" :quizType="taskResults.quizSettings.quizType" />
        </div>
        <div v-else-if="result.questionType == 'Text'">
          <text-question :isCardActive="textQuestion" :question="result" :quizType="taskResults.quizSettings.quizType" />
        </div>
        <div v-else-if="result.questionType == 'Sequence'">
          <sequence-question :isCardActive="sequenceQuestion" :question="result" :quizType="taskResults.quizSettings.quizType" />
        </div>
        <div v-else-if="result.questionType == 'Matching'">
          <matching-question :isCardActive="matchingQuestion" :question="result" :quizType="taskResults.quizSettings.quizType" />
        </div>
        <div v-else-if="result.questionType == 'Sentence' || result.questionType == 'MultipleChoiceText' || result.questionType == 'WordBank'">
          <sentence-question :isCardActive="sentenceQuestion" :question="result" :quizType="taskResults.quizSettings.quizType" />
        </div>
        <div v-else-if="result.questionType == 'LikertScale'">
          <likert-scale-question   :isCardActive="likertScaleQuestion" :question="result" :quizType="taskResults.quizSettings.quizType" />
        </div>
      </div>
    </div>
    <div v-else-if="taskResults && taskResults.quizId">
      <div v-for="(answer, answerIndex) in taskResults.answers" :key="answerIndex">
        <div v-if="answerIndex == 0">
          <quiz-info-view :isCardActive="quizInfoView" :quiz="taskResults.quizDetails" :info="taskResults" :newScore="quizAchievedMarks" :freeTextTotal="quizTotalMarks" :newQuizTotal="quizTotalMarks" />
        </div>
        <div v-if="answer.questionType == 1"> <!-- MultipleChoiceSingleAnswer -->
          <mcss-question :isCardActive="mcssQuestion" :question="taskResults" :answer="answer" />
        </div>
        <div v-else-if="answer.questionType == 2"> <!-- MultipleChoiceMultipleAnswers -->
          <mcms-question :isCardActive="mcmsQuestion" :question="taskResults" :answer="answer" />
        </div>
        <div v-else-if="answer.questionType == 3"> <!-- FreeText -->
          <free-text-question :isCardActive="freeTextQuestion" :question="taskResults" :answer="answer" />
        </div>
        <div v-else-if="answer.questionType == 4"> <!-- Table -->
          <table-question :isCardActive="tableQuestion" :question="taskResults" :answer="answer" />
        </div>
        <div v-else-if="answer.questionType == 5"> <!-- Drag And Drop -->
          <drag-and-drop :isCardActive="dragAndDropQuestion" :question="taskResults" :answer="answer" />
        </div>
        <div v-else-if="answer.questionType == 6"> <!-- FreeText -->
          <upload-question :isCardActive="freeTextQuestion" :question="taskResults" :answer="answer" />
        </div>
      </div>
    </div>
    <div v-else-if="taskResults && taskResults.uploadTaskId">
      <upload-task-view :isCardActive="uploadTaskView" :uploadTask="taskResults" />
    </div>
    <div v-else-if="taskResults && taskResults.videoCaptureTaskId">
      <capture-task-view :isCardActive="captureTaskView" :captureTask="taskResults" />
    </div>
    <div>
      <ispring-final-comment-view v-if="taskResults && !taskResults.quizId && !taskResults.uploadTaskId && !taskResults.videoCaptureTaskId" :isCardActive="ispringFinalCommentView && !(loadingView || errorLoadingView)" :totalScore="ispringTotalScore" :quizData="taskResults" />
      <quiz-final-comment-view v-else-if="taskResults && taskResults.quizId" :isCardActive="quizFinalCommentView && !(loadingView || errorLoadingView)" :quizAchievedMarks="quizAchievedMarks" :quizInfo="taskResults" :quizTextTotal="quizTotalMarks" :newQuizTotal="quizTotalMarks" />
      <upload-comment-view v-else-if="taskResults && taskResults.uploadTaskId" :isCardActive="uploadCommentView && !(loadingView || errorLoadingView)" :uploadTask="taskResults" />
      <capture-comment-view v-else-if="taskResults && taskResults.videoCaptureTaskId" :isCardActive="captureCommentView && !(loadingView || errorLoadingView)" :captureTask="taskResults" />
    </div>

    <vs-popup id="cellViewPopup" title="Confirm" :active.sync="rejectPopupConfirm">
      <div class="mt-3">
        By choosing 'Reassess or Return Comment', the assessment and any comments you made will be reviewed by an Assessor. Feedback will be given to you as soon as possible.
        <div class="float-right mt-5">
            <vs-button color="warning" @click="queryAssessment">OK</vs-button>
            <vs-button color="warning" class="ml-1" @click="rejectPopupConfirm = false">Cancel</vs-button>          
        </div>
      </div>
    </vs-popup>

    <vs-popup id="cellViewPopup" title="Confirm" :active.sync="confirmPopupConfirm">
      <div class="mt-3">
        By choosing 'Accept', you agree with the final results of this assessment and that any of the comments you made will be disregarded.
        <div class="float-right mt-5">
            <vs-button color="warning" @click="acceptAssessment">OK</vs-button>
            <vs-button color="warning" class="ml-1" @click="confirmPopupConfirm = false">Cancel</vs-button>          
        </div>
      </div>
    </vs-popup>

    <div v-if="taskResults.length != 0" class="vx-row">
      <div class="vx-col">
        <h3>{{`Remedial Count: ${remedialCount}/${remedialCount > 2 ? `${remedialCount}` : `2`}`}}</h3>
      </div>
      <vs-spacer></vs-spacer>
      <div id="buttons-container" class="vx-col">
        <vs-button color="success" class="mr-2 vs-con-loading__container" ref="acceptButton" @click="confirmAccept">Accept</vs-button>
        <vs-button color="danger" class="mr-6 vs-con-loading__container" ref="queryButton" @click="confirmQuery">Reassess or Return Comment</vs-button>
        <vs-button color="warning" type="border" class="mb-2" @click="closeTab">Cancel</vs-button>
      </div>
    </div>
  </div>
</template>

<script>
import ispringQuizInfoView from "./assessedviews/iSpringQuizInfoView.vue";
import multipleChoiceQuestion from "./assessedviews/MultipleChoiceQuestion.vue";
import multipleResponseQuestion from "./assessedviews/MultipleResponseQuestion.vue";
import textQuestion from "./assessedviews/TextQuestion.vue";
import sequenceQuestion from "./assessedviews/SequenceQuestion.vue";
import matchingQuestion from "./assessedviews/MatchingQuestion.vue";
import sentenceQuestion from "./assessedviews/SentenceQuestion.vue";
import likertScaleQuestion from "./assessedviews/LikertScaleQuestion.vue";
import quizInfoView from "./assessedviews/QuizInfoView.vue";
import dragAndDrop from "./assessedviews/DragAndDrop.vue";
import mcssQuestion from "./assessedviews/MCSSQuestion.vue";
import mcmsQuestion from "./assessedviews/MCMSQuestion.vue";
import freeTextQuestion from "./assessedviews/FreeTextQuestion.vue";
import uploadQuestion from "./assessedviews/UploadQuestion.vue";
import tableQuestion from "./assessedviews/TableQuestion.vue";
import uploadTaskView from "./assessedviews/UploadTaskView.vue";
import captureTaskView from "./assessedviews/CaptureTaskView.vue";
import loadingView from "./assessedviews/ResultsLoadingView.vue";
import errorLoadingView from "./assessedviews/ErrorLoadingView.vue";
import ispringFinalCommentView from "./assessedviews/iSpringFinalCommentView.vue";
import quizFinalCommentView from "./assessedviews/QuizFinalCommentView.vue";
import uploadCommentView from "./assessedviews/UploadCommentView.vue";
import captureCommentView from "./assessedviews/CaptureCommentView.vue";
import 'animate.css';
export default {
  components: {
    ispringQuizInfoView,
    multipleChoiceQuestion,
    multipleResponseQuestion,
    textQuestion,
    sequenceQuestion,
    matchingQuestion,
    sentenceQuestion,
    likertScaleQuestion,
    quizInfoView,
    dragAndDrop,
    mcssQuestion,
    mcmsQuestion,
    freeTextQuestion,
    tableQuestion,
    uploadTaskView,
    captureTaskView,
    loadingView,
    errorLoadingView,
    ispringFinalCommentView,
    quizFinalCommentView,
    uploadCommentView,
    captureCommentView,
    uploadQuestion
  },
  data() {
    return {
      isMounted: false,
      taskLogId: null,
      taskResults: [],
      ispringQuizInfoView: true,
      multipleChoiceQuestion: true,
      multipleResponseQuestion: true,
      textQuestion: true,
      sequenceQuestion: true,
      likertScaleQuestion: true,
      matchingQuestion: true,
      sentenceQuestion: true,
      quizInfoView: true,
      mcssQuestion: true,
      mcmsQuestion: true,
      freeTextQuestion: true,
      tableQuestion: true,
      uploadTaskView: true,
      captureTaskView: true,
      dragAndDropQuestion: true,
      snapshotView: true,
      loadingView: false,
      errorLoadingView: false,
      ispringFinalCommentView: true,
      quizFinalCommentView: true,
      ispringTotalScore: 0,
      quizAchievedMarks: 0,
      quizTotalMarks: 0,
      uploadCommentView: true,
      captureCommentView: true,
      statusId: 0,
      rejectPopupConfirm: false,
      confirmPopupConfirm: false,
      remedialCount:0,
    };
  },
  watch: {
    taskResults: {
      deep: true,
      handler() {
        var self = this;

        if(self.taskResults && !self.taskResults.quizId && !self.taskResults.uploadTaskId && !self.taskResults.videoCaptureTaskId){
          self.ispringTotalScore = 0;
          for(var i = 0; i < self.taskResults.questions.length; i++) {
            self.ispringTotalScore += parseInt(self.taskResults.questions[i].assessment.awardedPoints)
          }
        }
        else if(self.taskResults && self.taskResults.quizId){
          self.quizAchievedMarks = 0;
          self.quizTotalMarks = 0;
          for(var i = 0; i < self.taskResults.answers.length; i++) {
            self.quizAchievedMarks += self.taskResults.answers[i].questionAchievedMarks == "" ? 0 : parseInt(self.taskResults.answers[i].questionAchievedMarks)
          }

          for(var i = 0; i < self.taskResults.answers.length; i++) {
            self.quizTotalMarks += parseInt(self.taskResults.answers[i].questionTotalMarks)
          }

          for(var i = 0; i < self.taskResults.answers.length; i++) {
            self.quizTotalMarks += parseInt(self.taskResults.answers[i].textOriginalTotalPoints)
          }

          for(var i = 0; i < self.taskResults.answers.length; i++) {
            self.quizTotalMarks += parseInt(self.taskResults.answers[i].tableOriginalTotalPoints)
          }
        }
      }
    }
  },
  computed: {

  },
  methods: {
    closeTab() {
      this.close();
    },
    close() {
      window.open("", "_self").close();
    },
    initValues() {
      this.isMounted = false;
      this.taskLogId = null;
      this.taskResults = [];
      this.errors.clear();
    },
    loadTask() {
      const self = this;
      self.loadingView = true;

      var onSuccess = function(response) {
        if (response.data) {
          self.taskResults = response.data;
          self.taskResults.newUploadedFiles = [];
        }
      };

      var onFinally = function() {
        self.loadingView = false;
        if (!self.loadingView && self.taskResults.length == 0)
          self.errorLoadingView = true;
      };

      self.$ajaxGet(self, "student/GetTask/" + self.$route.query.TaskLogId, onSuccess, onFinally);
    },
    acceptAssessment(){
      var self = this;

      self.showLoadingOnElement("acceptButton", 0.45, "material");

      var onSuccess = response => {
        self.$vs.loading.close(self.$refs.acceptButton.$el);
        self.closeTab();
      };

      var assessmentReview = {};
      assessmentReview.logId = self.$route.query.TaskLogId;
      assessmentReview.statusId = self.statusId;

      if(self.taskResults && !self.taskResults.quizId && !self.taskResults.uploadTaskId && !self.taskResults.videoCaptureTaskId) {
        assessmentReview.assessment = self.taskResults.questions.map(function(item) {return item.assessment});
        assessmentReview.finalStudentComment = self.taskResults.finalStudentComment;

        self.$ajaxPost(self, "ISpringQuizAssessment/AcceptedByStudent", assessmentReview, onSuccess);
      }
      else if(self.taskResults && self.taskResults.quizId) {
        assessmentReview.quizId = self.taskResults.quizId;
        assessmentReview.quizAnswers = self.taskResults.answers;
        assessmentReview.finalStudentComment = self.taskResults.finalStudentComment;

        self.$ajaxPost(self, "QuizAssessment/AcceptedByStudent", assessmentReview, onSuccess);
      }
      else if(self.taskResults && self.taskResults.uploadTaskId) {
        assessmentReview.studentComment = self.taskResults.studentComment;

        self.$ajaxPost(self, "UploadAssessment/AcceptedByStudent", assessmentReview, onSuccess);
      }
      else if(self.taskResults && self.taskResults.videoCaptureTaskId) {
        assessmentReview.studentComment = self.taskResults.studentComment;

        self.$ajaxPost(self, "CaptureAssessment/AcceptedByStudent", assessmentReview, onSuccess);
      }
    },
    queryAssessment(){
      var self = this;
      self.showLoadingOnElement("queryButton", 0.45, "material");

      var onSuccess = response => {
        self.$vs.loading.close(self.$refs.queryButton.$el);
        self.closeTab();
      };

      var assessmentReview = {};
      assessmentReview.logId = self.$route.query.TaskLogId;
      assessmentReview.statusId = self.statusId;

      if(self.taskResults && !self.taskResults.quizId && !self.taskResults.uploadTaskId && !self.taskResults.videoCaptureTaskId) {
        assessmentReview.assessment = self.taskResults.questions.map(function(item) {return item.assessment});
        assessmentReview.finalStudentComment = self.taskResults.finalStudentComment;

        self.$ajaxPost(self, "ISpringQuizAssessment/QueryByStudent", assessmentReview, onSuccess);
      }
      else if(self.taskResults && self.taskResults.quizId) {
        assessmentReview.quizId = self.taskResults.quizId;
        assessmentReview.quizAnswers = self.taskResults.answers;
        assessmentReview.quizAnswers.forEach(element => {
          if(element.reuploadedFileAsComment){
            if(!element.studentComment){
              element.studentComment = "";
            }
            element.reuploadedFileAsComment.forEach(reuploadedFile => {
              element.studentComment = element.studentComment.concat(` [${reuploadedFile}]`)
            });
          }
        });
        assessmentReview.finalStudentComment = self.taskResults.finalStudentComment;

        self.$ajaxPost(self, "QuizAssessment/QueryByStudent", assessmentReview, onSuccess);
      }
      else if(self.taskResults && self.taskResults.uploadTaskId) {
        assessmentReview.studentComment = self.taskResults.studentComment;

        assessmentReview.NewFileTaskLogDTO = {
          logId: assessmentReview.logId,
          newUploadedFiles: self.taskResults.newUploadedFiles
        }

        self.$ajaxPost(self, "UploadAssessment/QueryByStudent", assessmentReview, onSuccess);
      }
      else if(self.taskResults && self.taskResults.videoCaptureTaskId) {
        assessmentReview.studentComment = self.taskResults.studentComment;

        assessmentReview.NewFileTaskLogDTO = {
          logId: assessmentReview.logId,
          newUploadedFiles: self.taskResults.newUploadedFiles
        }

        self.$ajaxPost(self, "CaptureAssessment/QueryByStudent", assessmentReview, onSuccess);
      }
    },
    confirmAccept(){
      var self = this;

      var unansweredComments = [];
      var questionId = null;

      if (self.$siteTypeId() != 1) {
        if (self.taskResults && self.taskResults.quizId) {
          unansweredComments = self.taskResults.answers.filter(x => x.lastCommentBy && x.lastCommentBy.includes("Assessor") && !x.studentComment);
          questionId = unansweredComments.length > 0 ? unansweredComments[0].questionId : null;
        } else if (self.taskResults && !self.taskResults.quizId && !self.taskResults.uploadTaskId && !self.taskResults.videoCaptureTaskId) {
          unansweredComments = self.taskResults.questions.filter(x => x.assessment && x.assessment.lastCommentBy && x.assessment.lastCommentBy.includes("Assessor") && !x.assessment.studentComment);
          questionId = unansweredComments.length > 0 ? unansweredComments[0].assessment.questionId : null;
        }
      }

      if (self.$siteTypeId() != 1 && unansweredComments.length > 0) {
        self.$swal({
          title: 'Cannot Continue',
          icon: 'error',
          html: "Please ensure that you have given feedback to all of the assessor's comments in the relevant <strong>comment boxes</strong>.",
          customClass: {
            confirmButton: 'vs-component vs-button vs-button-primary vs-button-filled',
          },
          showClass: {
            popup: 'animate__animated animate__bounceIn',
          },
          buttonsStyling: false,
        }).then((result) => {
          if (result.value) { // <-- if confirmed
            self.scrollToElement(`question-card_${questionId}`);
          }
        });
      } else {
        self.statusId = 6;
        self.confirmPopupConfirm = true;
      }
    },
    confirmQuery(){
      var self = this;

      var unansweredComments = [];
      var questionId = null;

      if (self.$siteTypeId() != 1) {
        if (self.taskResults && self.taskResults.quizId) {
          unansweredComments = self.taskResults.answers.filter(x => x.lastCommentBy && x.lastCommentBy.includes("Assessor") && !x.studentComment);
          questionId = unansweredComments.length > 0 ? unansweredComments[0].questionId : null;
        } else if (self.taskResults && !self.taskResults.quizId && !self.taskResults.uploadTaskId && !self.taskResults.videoCaptureTaskId) {
          unansweredComments = self.taskResults.questions.filter(x => x.assessment && x.assessment.lastCommentBy && x.assessment.lastCommentBy.includes("Assessor") && !x.assessment.studentComment);
          questionId = unansweredComments.length > 0 ? unansweredComments[0].assessment.questionId : null;
        }
      }

      if (self.$siteTypeId() != 1 && unansweredComments.length > 0) {
        self.$swal({
          title: 'Cannot Continue',
          icon: 'error',
          html: "Please ensure that you have given feedback to all of the assessor's comments in the relevant <strong>comment boxes</strong>.",
          customClass: {
            confirmButton: 'vs-component vs-button vs-button-primary vs-button-filled',
          },
          showClass: {
            popup: 'animate__animated animate__bounceIn',
          },
          buttonsStyling: false,
        }).then((result) => {
          if (result.value) { // <-- if confirmed
            self.scrollToElement(`question-card_${questionId}`);
          }
        });
      } else {
        self.statusId = 5;
        self.rejectPopupConfirm = true;
      }
    },
    scrollToElement(elementId) {
      var scrollOptions = {
        easing: "ease-in-out",
        offset: -100,
        force: true,
        cancelable: true,
        x: false,
        y: true
      };
      var cancelScroll = this.$scrollTo(document.getElementById(elementId), 500, scrollOptions);
    },
    showLoadingOnElement(element, scale, type){
      var self = this;
      self.$vs.loading({
        type: type,
        container: self.$refs[element].$el,
        scale: scale
      });
    },
    getRemedialCount(){
      var self = this;

      var onSuccess = response =>{
        self.remedialCount = response.data;
      }

      self.$ajaxGet(self, `CourseTaskLog/GetRemedialCount/${self.$route.query.TaskLogId}` , onSuccess);
    },
    remedialCountPopup(){
      var self = this;
      var timerInterval = 4000;
      self.$swal({
        title: `Remedial Attempt ${self.remedialCount} / ${self.remedialCount > 2 ? `${self.remedialCount}` :'2' }`,
        html: `<p>If you don't give the required information by the conclusion of the second remedial attempt (2/2), you won't be able to try again unless the assessor grants permission.</p> <p class="mt-3 time-area">Close in <b></b></p>`,
        timer: 4000,
        timerProgressBar: true,
        confirmButtonText:'Close',
        showConfirmButton: true,
        didOpen: () => {
          self.$swal.showLoading()
          const b = self.$swal.getHtmlContainer().querySelector('b')
          timerInterval = setInterval(() => {
            b.textContent = Math.round(self.$swal.getTimerLeft() / 60).toFixed(0);
            if(b.textContent < 10){
              self.$swal.toggleTimer()
              self.$swal.hideLoading()
              clearInterval(timerInterval);
              const timerarea = self.$swal.getHtmlContainer().querySelector('.time-area')
              timerarea.style.display = 'none';
            }
          }, 100)
        },
      }).then((result) => {

      })
    }
  },
  created() {
    this.$store.dispatch("updateTheme", "dark");
  },
  mounted() {
    var self = this;
    self.loadTask();
    self.getRemedialCount();
    self.isMounted = true;

    self.$swal({
      title: 'Information',
      icon: 'info',
      html: "<p class='mb-3'>This assessment has been sent back from the assessor because some of your answers are incorrect. Please fill in the correct answers in the suggested comment boxes to allow the assessor to reassess your answers.</p><p>You will not be able to complete the assessment if you do not supply the correct answers in the comment boxes. You have three attempts to provide the correct answers in the comments.</p>",
      customClass: {
        confirmButton: 'vs-component vs-button vs-button-primary vs-button-filled',
      },
      showClass: {
        popup: 'animate__animated animate__bounceIn',
      },
      buttonsStyling: false,
    }).then((result) => {
        self.remedialCountPopup();
    });
  }
}
</script>
<style lang="scss">
@media screen and (max-width: 644px) {
  #buttons-container {
    margin-top: 20px;
    margin-left: auto;
    margin-right: auto;
  }
  
}
  
</style>
